module.exports = __webpack_public_path__ + "img/tip-icon.b03debf3.png";